// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_GaleriaFotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** Nested item of SiteUnidades_SalvarInput::$galeria. */
import { registerContract } from './validate'

export interface SiteUnidades_GaleriaFotoInput {
foto_url: string
foto_alt?: string
}

registerContract('SiteUnidades_GaleriaFotoInput', {
  foto_url: { type: 'string',  required: true },
  foto_alt: { type: 'string',  required: false },
})
